import React from "react";
import PropTypes from "prop-types";
import { graphColors } from "utils/styles";
import { Pie, PieChart, Tooltip, ResponsiveContainer, Cell } from "recharts";

const SENTIMENT_COLORS = {
  Positive: "#4CAF50",
  Neutral: "#9E9E9E",
  Negative: "#F44336"
};

const SentimentChart = ({ patientSentiment }) => {
  if (!patientSentiment || Object.keys(patientSentiment).length === 0) {
    return (
      <div className="graph-container">
        <h4 className="graph-header">Patient Sentiment</h4>
        <div className="no-data-message">No sentiment data available</div>
      </div>
    );
  }

  const data = Object.entries(patientSentiment).map(([key, value]) => ({
    label: key,
    value,
    fill: SENTIMENT_COLORS[key] || graphColors[Object.keys(patientSentiment).indexOf(key) % graphColors.length]
  }));

  return (
    <div className="graph-container">
      <h4 className="graph-header">Patient Sentiment</h4>
      <ResponsiveContainer height={250}>
        <PieChart>
          <Pie
            data={data}
            dataKey="value"
            nameKey="label"
            cx="50%"
            cy="50%"
            outerRadius={80}
            isAnimationActive={false}
            label={({ label, percent }) => `${label}: ${(percent * 100).toFixed(0)}%`}
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.fill} />
            ))}
          </Pie>
          <Tooltip formatter={(value, name) => [value, name]} />
        </PieChart>
      </ResponsiveContainer>
      <div className="chart-legend">
        {data.map((item, i) => (
          <div key={i} className="legend-item">
            <div className="legend-color" style={{ backgroundColor: item.fill }} />
            <span>{item.label}: {item.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

SentimentChart.propTypes = {
  patientSentiment: PropTypes.object
};

export default SentimentChart;
